<app-panel-header-image-view pretitle="{{'Athletes' | transloco}}" title="{{'Search' | transloco}}" banner_image="../../../../modules/custom/wa_angular/app/assets/images/athletes-header.jpg"></app-panel-header-image-view>

  <app-app-content-page-wrapper>
  <app-bootstrap-members-athletes-filters></app-bootstrap-members-athletes-filters>
  <app-wa-table  [customMsgBox]="customBox" [showNoResultsMessageCondition]="ShowNoResultsBox" [showNoResultsMessage]="customLoadMsg" [isSortableFunc]="sortClass" [showCondition]="true" [headers]="headers()" [isDataLoading]="loading"
  [areMoreData]="areMoreData()" (loadMore)="loadMore()" [data]="data" (headerClick)="changeSort($event)">
  <app-search-box-table #customBox [subtitle]="'find.athletes'|transloco">

  </app-search-box-table>
  <ng-template [extraClass]="['wa-table__cell--fit-right']" app-column let-athlete>
                <lib-athlete-rank *ngIf="(categorySelected() && athlete.WorldRankings[0].Rnk !== 0) && (currentCategory.Code == athlete.WorldRankings[0].Cat)"  [rankPrevious]="athlete.WorldRankings[0].Rnk" [rank]="athlete.WorldRankings[0].Rnk"></lib-athlete-rank>
                <lib-athlete-photo [id]="athlete.Id" [isTeam]="false"></lib-athlete-photo>

  </ng-template>
  <ng-template  app-column let-athlete>
    <lib-athlete-name [fname]="athlete.FName" [gname]="athlete.GName" [wnameord]="athlete.WNameOrd" [id]="athlete.Id"></lib-athlete-name>
  </ng-template>
  <ng-template  [extraClass]="[]" app-column let-athlete>
    <lib-country-flag [name]="getCountryName(getCountryCode(athlete))" [id]="getCountryCode(athlete)"> </lib-country-flag>
  </ng-template>
  <ng-template  [extraClass]="['center-text']" app-column let-athlete>
    <div class="uppertext">{{athlete.Age}}</div>
  </ng-template>
  <ng-template *ngIf="categorySelected()"  [extraClass]="['center-text']"  app-column let-athlete><p class="uppertext-black">{{athlete.SeasonStats[0].AverageArr.toFixed(2)}}</p></ng-template>
  <ng-template *ngIf="categorySelected()"  [extraClass]="['center-text']" app-column let-athlete><p class="uppertext-black">{{athlete.SeasonStats[0].MatchWinPercentage.toFixed(0)}}%</p></ng-template>
  <ng-template *ngIf="!categorySelected()" [extraClass]="['center-text']" app-column let-athlete>
    <ng-container *ngFor="let rank of athlete.WorldRankings">
      <span class="tag tag--clickable" *ngIf="rank.Cat != ''; else empty" (click)="selectCategory(getCategoryByCode(rank.Cat))">
        {{getCategoryByCode(rank.Cat).Name}}
      </span>
      <ng-template #empty>&nbsp;&nbsp;</ng-template>
    </ng-container>
  </ng-template>

  <ng-template  [extraClass]="['wa-table__cell--fit-right']" app-column-responsive let-athlete>
      <lib-athlete-rank  *ngIf="(categorySelected() && athlete.WorldRankings[0].Rnk !== 0) && (currentCategory.Code == athlete.WorldRankings[0].Cat)"    [rankPrevious]="athlete.WorldRankings[0].Rnk" [rank]="athlete.WorldRankings[0].Rnk"></lib-athlete-rank>
      <lib-athlete-photo [id]="athlete.Id" [isTeam]="false"></lib-athlete-photo>
  </ng-template>
  <ng-template  app-column-responsive let-athlete>
    <lib-athlete-name [fname]="athlete.FName" [gname]="athlete.GName" [wnameord]="athlete.WNameOrd" [id]="athlete.Id"></lib-athlete-name>
    <div class="inner-info">
      <div><p class="uppertext-black">{{'Country' | transloco}}:          </p>      <lib-country-flag [name]="getCountryName(getCountryCode(athlete))" [id]="getCountryCode(athlete)"> </lib-country-flag></div>
      <div><p class="uppertext-black">{{'Age' | transloco}}:          </p>  {{athlete.Age}}   </div>
      <div *ngIf="!categorySelected()">
        <ng-container *ngFor="let rank of athlete.WorldRankings">
        <span class="tag tag--clickable" *ngIf="rank.Cat != ''; else empty" (click)="selectCategory(getCategoryByCode(rank.Cat))">
          {{getCategoryByCode(rank.Cat).Name}}
        </span>
        <ng-template #empty>&nbsp;&nbsp;</ng-template>
      </ng-container></div>
      <div *ngIf="categorySelected()" ><p class="uppertext-black">{{'average_arrow' | transloco}}:    </p>  {{athlete.SeasonStats[0].AverageArr.toFixed(2)}}</div>
      <div *ngIf="categorySelected()" ><p class="uppertext-black">{{'match_percent' | transloco}}:       </p>{{athlete.SeasonStats[0].MatchWinPercentage.toFixed(0)}}%</div>
    </div>
  </ng-template>
</app-wa-table>
<app-news-panel [title]="'related_news' | transloco" [news]="news" *ngIf="news && news.length > 0"></app-news-panel>
</app-app-content-page-wrapper>

